import classNames from "classnames";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { type SvgIconProps } from "~/common/mui";
import { IconSize } from "~/common/mui/icons/IconSize";

export interface Props extends Omit<SvgIconProps, "fontSize"> {
  isActive?: boolean;
  size?: IconSize | number;
}

const iconSizeToPx = (size: IconSize | number): number => {
  if (typeof size === "number") {
    return size;
  }

  switch (size) {
    case IconSize.FONT_10:
      return 10;
    case IconSize.FONT_16:
      return 16;
    case IconSize.FONT_20:
      return 20;
    case IconSize.FONT_24:
      return 24;
    case IconSize.FONT_30:
      return 30;
    case IconSize.FONT_50:
      return 50;
    case IconSize.FONT_64:
      return 64;
    default:
      return 24;
  }
};

export const TeaserToggleIcon = ({ isActive, className, size = IconSize.FONT_24, style, ...rest }: Props) => {
  const ToggleIcon = isActive ? ArrowDropUpIcon : ArrowDropDownIcon;

  return (
    <ToggleIcon
      className={classNames(typeof size === "string" ? size : undefined, className, "d-flex")}
      style={{ ...style, fontSize: iconSizeToPx(size) }}
      {...rest}
    />
  );
};
